import { useTranslation } from "react-i18next";
import Actions from "../../../../../Actions";
import { BOOKING_STEPS } from "../../utils/constants";

const { STEP_REVIEW, STEP_PRICE_PACKAGE, STEP_PREVIEWS_NEW, STEP_BEWERBERHUB, STEP_BASE_DATA } =
  BOOKING_STEPS;

function useCampaignCreationSteps() {
  const { t } = useTranslation();

  const redirectBack = (currentStep, hideQualificationQuestions = false) => {
    if (currentStep === STEP_BASE_DATA) {
      return Actions.campaignCreateUpdateBudgetData({ currentStep: STEP_BASE_DATA });
    }

    if (currentStep === STEP_PRICE_PACKAGE) {
      return Actions.campaignCreateUpdateBudgetData({ currentStep: STEP_BASE_DATA });
    }

    if (currentStep === STEP_PREVIEWS_NEW) {
      return Actions.campaignCreateUpdateBudgetData({ currentStep: STEP_PRICE_PACKAGE });
    }

    if (currentStep === STEP_BEWERBERHUB) {
      return Actions.campaignCreateUpdateBudgetData({ currentStep: STEP_PREVIEWS_NEW });
    }

    if (currentStep === STEP_REVIEW) {
      return Actions.campaignCreateUpdateBudgetData({
        currentStep: hideQualificationQuestions ? STEP_PREVIEWS_NEW : STEP_BEWERBERHUB
      });
    }
  };

  const redirectNext = (e, currentStep, onNextStep) => {
    e.preventDefault();

    const isCampaignCreationStep = currentStep === STEP_REVIEW;
    const isStartCampaignCreationStep = currentStep === STEP_BASE_DATA;

    if (isCampaignCreationStep) return Actions.emitCampaignCreation(true);

    if (isStartCampaignCreationStep) return Actions.startCampaignCreation(true);

    return onNextStep();
  };

  const continueLabel = (currentStep) => {
    if (currentStep === STEP_BASE_DATA) {
      return t("Go to budget selection");
    }

    if (currentStep === STEP_PRICE_PACKAGE) {
      return t("Go to the ad preview");
    }

    if (currentStep === STEP_REVIEW) {
      return t("Book now");
    }

    return t("Continue");
  };

  return { redirectBack, redirectNext, continueLabel };
}

export default useCampaignCreationSteps;
